import * as React from 'react';

const iconImageURL = require('../../assets/icons/styles.jpg');

export default () => <img src={iconImageURL} />;
